"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByLastMessageAndStatus = exports.sortByLastMessage = exports.parseChats = exports.getPartnerIdFromChat = exports.getNextChat = exports.getFirstByLastMessage = void 0;
var _dateutil = require("./dateutil");
var _timeUtil = require("./timeUtil");
var _excluded = ["lastMessageAt", "userId", "ad", "seller", "buyer", "favorite"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var getFirstByLastMessage = exports.getFirstByLastMessage = function getFirstByLastMessage() {
  var chats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var orderedChats = sortByLastMessageAndStatus(chats);
  return orderedChats[0] && orderedChats[0] || null;
};
var sortByLastMessageAndStatus = exports.sortByLastMessageAndStatus = function sortByLastMessageAndStatus() {
  var chats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _chats$reduce = chats.reduce(function (acc, chat) {
      var adStatus = chat.adStatus,
        lastMessageBy = chat.lastMessageBy;
      if (lastMessageBy) {
        if (adStatus === 'active' || adStatus === 'active_sold') {
          acc.active.push(chat);
        } else {
          acc.inactive.push(chat);
        }
      }
      return acc;
    }, {
      active: [],
      inactive: []
    }),
    active = _chats$reduce.active,
    inactive = _chats$reduce.inactive;
  return [].concat(_toConsumableArray(sortByLastMessage(active)), _toConsumableArray(sortByLastMessage(inactive)));
};
var sortByLastMessage = exports.sortByLastMessage = function sortByLastMessage() {
  var chats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return chats.sort(function (a, b) {
    var lastMessageA = a.lastMessageAt;
    var lastMessageB = b.lastMessageAt;
    return (0, _dateutil.parseDate)(lastMessageB) - (0, _dateutil.parseDate)(lastMessageA);
  });
};
var getNextChat = exports.getNextChat = function getNextChat(chats, currentRoomname) {
  var currentIndex = chats.findIndex(function (_ref) {
    var roomname = _ref.roomname;
    return roomname === currentRoomname;
  });
  if (chats[currentIndex + 1]) {
    return {
      nextChat: chats[currentIndex + 1],
      chatIndex: currentIndex + 1
    };
  }
  if (chats[currentIndex - 1]) {
    return {
      nextChat: chats[currentIndex - 1],
      chatIndex: currentIndex - 1
    };
  }

  // empty chatlist receiving first contact
  return {
    nextChat: null,
    chatIndex: null
  };
};
var getPartnerIdFromChat = exports.getPartnerIdFromChat = function getPartnerIdFromChat(chat) {
  var username = chat.username,
    sellerId = chat.sellerId,
    buyerId = chat.buyerId;
  return username === sellerId ? buyerId : sellerId;
};
var parseChats = exports.parseChats = function parseChats() {
  var chats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var serverTimestamp = arguments.length > 1 ? arguments[1] : undefined;
  return chats.map(function (chat) {
    var originalLastMessageAt = chat.lastMessageAt,
      userId = chat.userId,
      ad = chat.ad,
      seller = chat.seller,
      buyer = chat.buyer,
      favorite = chat.favorite,
      otherProps = _objectWithoutProperties(chat, _excluded);
    var timestampDelta = (0, _timeUtil.calcTimestampDelta)(serverTimestamp);
    var lastMessageAt = (0, _timeUtil.applyTimestampDelta)(originalLastMessageAt, timestampDelta);
    return _objectSpread(_objectSpread({}, otherProps), {}, {
      originalLastMessageAt: originalLastMessageAt,
      lastMessageAt: lastMessageAt,
      username: String(userId),
      sellerId: seller.id,
      sellerName: seller.name,
      buyerId: buyer.id,
      buyerName: buyer.name,
      listId: ad.listId,
      adStatus: ad.status,
      category: ad.category,
      olxPay: ad.olxPay,
      subject: ad.subject,
      image: ad.image,
      price: ad.price,
      isFavoriteChat: favorite
    });
  });
};